<app-context-menu
  [options]="{ width: '240px', openOnHover: true, allowClicks: true, noSpacing: true, hoverDelay: 300 }"
  [disabled]="userIsDeleted()"
  #menu
>
  <div contextButton class="mention" [class.deleted]="userIsDeleted()">
    @if (userIsDeleted()) {
      <span>Deleted User</span>
    } @else {
      <app-avatar [user]="user()"></app-avatar>
      <span>{{ user().first_name || 'Unnamed User' }} {{ user().last_name }}</span>
    }
  </div>

  <div contextContent>
    @if (menu.isOpen()) {
      <app-profile-preview [user]="user()" [email]="user().email" [isTeamMember]="isTeamMember"></app-profile-preview>
    }
  </div>
</app-context-menu>
